import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import {
    EpimsGate_FEATURE_KEY,EpimsGate_FEATURE_KEY_Document,EpimsGate_FEATURE_KEY_Language,
    EPIMSGateState,
    EPIMSGatePartialState,
    EPIMSGateAdapter,
    UploadStatus,
  
} from './anchorepimsgates.reducer';

// Lookup the 'Stakeholder Reference' feature state managed by NgRx
export const getEPIMSGateState = createFeatureSelector<
EPIMSGatePartialState,
EPIMSGateState
>(EpimsGate_FEATURE_KEY);


export const getEPIMSGateStateDocument = createFeatureSelector<
EPIMSGatePartialState,
EPIMSGateState
>(EpimsGate_FEATURE_KEY_Document);

export const getEPIMSGateStateLanguage = createFeatureSelector<
EPIMSGatePartialState,
EPIMSGateState
>(EpimsGate_FEATURE_KEY_Language);



const { selectAll, selectEntities } = EPIMSGateAdapter.getSelectors();


export function switchStateSlice(type): any {

   if(type === 'Document')
   {
    console.log('Type Passed in Selector Function',type )
     return getEPIMSGateStateDocument;
   }
   if(type === 'Engagement')
   {
    return getEPIMSGateState;
   }

   if(type === 'Language'){
     return getEPIMSGateStateLanguage;
   }
}

export const getAllEPIMS = (type) => {
  console.log('Type Passed in Selector',type )
  

  return createSelector(
    switchStateSlice(type),
      (state: EPIMSGateState) => selectAll(state)
    );
}


export const getEPIMSError = createSelector(
    getEPIMSGateState,
  (state: EPIMSGateState) =>  state.error
);

export const loadingEPIMS = createSelector(
    getEPIMSGateState,
  (state: EPIMSGateState) =>  state.loaded
);

// export const getAllEPIMS = createSelector(
//   getEPIMSGateStateDocument,
//   (state: EPIMSGateState) => selectAll(state)
// );

// export const getAllEPIMS = createSelector(
//   getEPIMSGateStateDocument,
//   (state: EPIMSGateState) => selectAll(state)
// );

export const getEPIMSEntities = createSelector(
    getEPIMSGateState,
  (state: EPIMSGateState) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getEPIMSGateState,
  (state: EPIMSGateState) => state.selectedId
);

export const getSelected = createSelector(
    getEPIMSEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);



const getError = (state: EPIMSGateState): string => state.error;

const getStarted = (state: EPIMSGateState): boolean =>
  state.status === UploadStatus.Started;

const getRequested = (state: EPIMSGateState): boolean =>
  state.status === UploadStatus.Requested;

const getReady = (state: EPIMSGateState): boolean => state.status === UploadStatus.Ready;

const getProgress = (state: EPIMSGateState): number => state.progress;

const getInProgress = (state: EPIMSGateState): boolean =>
  state.status === UploadStatus.Started && state.progress >= 0;

const getFailed = (state: EPIMSGateState): boolean =>
  state.status === UploadStatus.Failed;

const getCompleted = (state: EPIMSGateState): boolean =>
  state.status === UploadStatus.Completed;



  export const selectUploadFileError: MemoizedSelector<
  object,
  string
> = createSelector(
  getEPIMSGateState,
  getError
);

export const selectUploadFileReady: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getEPIMSGateState,
  getReady
);

export const selectUploadFileRequested: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getEPIMSGateState,
  getRequested
);

export const selectUploadFileStarted: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getEPIMSGateState,
  getStarted
);

export const selectUploadFileProgress: MemoizedSelector<
  object,
  number
> = createSelector(
  getEPIMSGateState,
  getProgress
);

export const selectUploadFileInProgress: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getEPIMSGateState,
  getInProgress
);

export const selectUploadFileFailed: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getEPIMSGateState,
  getFailed
);

export const selectUploadFileCompleted: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getEPIMSGateState,
  getCompleted
);








